import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FareSuggestionChartModule } from "@shopping-angular-components/fare-suggestion-chart";
import {FareSuggestionChartContainerComponent} from './fare-suggestion-chart-container.component';
import {TextModule} from '../text/text.module';


@NgModule({
  declarations: [
    FareSuggestionChartContainerComponent
  ],
  imports: [
    CommonModule,
    FareSuggestionChartModule,
    TextModule
  ],
  exports: [
    FareSuggestionChartContainerComponent
  ]
})
export class FareSuggestionChartContainerModule {
}
